import React from 'react'
import { observer } from 'mobx-react'
import { Th, Td } from '@chakra-ui/react'

export interface TableCellProps {
  value: any
  isHeader: boolean
}

const TableCell = ({ value, isHeader }: TableCellProps) => {
  if (isHeader) {
    return (
      <Th color="white" bg="blue.700" padding="8px" borderBottom="none" textAlign="left">
        {value}
      </Th>
    )
  } else {
    return (
      <Td padding="8px" borderBottom="none">
        {value}
      </Td>
    )
  }
}

export default observer(TableCell)
